export default {
  logout: 'Logout',
  login: 'Login',
  personalAccount: 'Personal Account',
  messages: 'Messages',
  models: 'Models',
  statistics: 'Statistics',
  menu: 'Menu',
  noNewMessages: 'No new messages',
  selectCompany: 'Choose a company',
  withoutCompany: 'Without a company',
  manageCompany: 'Company management',
  marketing: 'Marketing',
  digitalCatalog: 'Digital Catalog',
  estimate: 'Project need',
  lobby: 'Lobby',
  showCase: 'Showcase of models',
  plugins: 'Plugins',
  dashboard: 'Dashboard',
  tarifs: 'Tariffs',
  articles: 'Articles',
  videos: 'Videos',
  products: 'Products',
  ntd: 'NTD',
  properties: 'Properties',
  map: 'Map / Object table',
  stocks: 'Stocks',
  deposit: 'Deposit',
  documents: 'Documents',
  profile: 'My profile',
  companies: 'My companies',
  settings: 'Settings',
  support: 'Support',
}
